import { useQuery } from '@tanstack/react-query';
import { get } from 'api/base';

type LastRecordingLanguageResponse = { results: { language: { code: string } | null }[] };

export const lastRecordingLanguageKey = (medatixxPatientId: string | undefined) =>
  ['lastRecordingLanguage', medatixxPatientId] as const;

export function useLastRecordingLanguage(medatixxPatientId: string | undefined) {
  const { data, isFetched, isLoadingError, error } = useQuery({
    queryKey: lastRecordingLanguageKey(medatixxPatientId),
    queryFn: () =>
      get('conversations', undefined, {
        medatixxPatientId,
        hasLanguage: 'true',
        mine: 'true',
        page_size: 1,
      }) as Promise<LastRecordingLanguageResponse>,
    enabled: !!medatixxPatientId,
  });

  return { language: data?.results[0]?.language?.code, isFetched, isLoadingError, error };
}
